import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useDocumentChecklistsTableContext } from '../../../../../DocumentChecklistsTableContext'
import { HelpMessage } from 'utils/constants'

export const EditDocumentChecklistItemModalBody: React.FC = () => {
  const {
    selectOptions: { placementTypesOptions },
  } = useDocumentChecklistsTableContext()
  return (
    <>
      <CIMSFormItem
        name="name"
        label="Name"
        help={HelpMessage.Concrete.DocumentChecklists.Name}
        requiredMessage="Please enter a name"
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="placementTypeIds"
        label="Placement Types"
        help={HelpMessage.Concrete.DocumentChecklists.PlacementTypes}
      >
        <CIMSSelect simple multiple options={placementTypesOptions} />
      </CIMSFormItem>
    </>
  )
}

export interface EditDocumentChecklistItemModalValues {
  name: string
  placementTypeIds?: string[]
}
